import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axiosInstance";

const CourseAdmin = () => {
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();

const fetchCourses = async () => {
  const res = await api.get("/api/courses");
  console.log("Fetched courses:", res.data);
  console.log("Courses count:", res.data.count);
  
  // Use res.data.data to get the actual array
  setCourses(res.data.data);
};

  useEffect(() => {
    fetchCourses();
  }, []);

  const deleteCourse = async (id) => {
  if (!window.confirm("Delete this course?")) return;
  
  try {
    console.log("Deleting course with ID:", id);
    const response = await api.delete(`/api/courses/${id}`);
    console.log("Delete response:", response.data);
    
    // Remove course from state immediately - no refetch needed
    setCourses(prev => prev.filter(course => course._id !== id));
  } catch (error) {
    console.error("Delete error:", error);
    console.error("Delete error response:", error.response?.data);
    alert(`Failed to delete course: ${error.response?.data?.message || error.message}`);
  }
};

  return (
    <div>
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Courses</h1>
        <button
          onClick={() => navigate("new")}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          + New Course
        </button>
      </div>

      <table className="w-full border bg-card rounded">
        <thead className="bg-muted">
          <tr>
            <th className="p-3">Title</th>
            <th className="p-3">Level</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>

        <tbody>
          {courses.map((course) => (
            <tr key={course._id} className="border-t">
              <td className="p-3">{course.title}</td>
              <td className="p-3">{course.level}</td>
              <td className="p-3 flex gap-3">
                <button
                  onClick={() => navigate(`${course._id}/edit`)}
                  className="text-blue-600"
                >
                  Edit
                </button>
                <button
                  onClick={() => deleteCourse(course._id)}
                  className="text-red-600"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CourseAdmin;
